import React from 'react';
import { Spinner } from './style';

export default () => <Spinner className='material-icons'>cached</Spinner>;
